/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Tenant_NameInputs */

const es_admin_company_overview_tenant_name = /** @type {(inputs: Admin_Company_Overview_Tenant_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la empresa`)
};

const en_admin_company_overview_tenant_name = /** @type {(inputs: Admin_Company_Overview_Tenant_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Name`)
};

/**
* | output |
* | --- |
* | "Company Name" |
*
* @param {Admin_Company_Overview_Tenant_NameInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_tenant_name = /** @type {((inputs?: Admin_Company_Overview_Tenant_NameInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Tenant_NameInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_tenant_name(inputs)
	return en_admin_company_overview_tenant_name(inputs)
});
export { admin_company_overview_tenant_name as "admin.company_overview.tenant_name" }